import type { HistoryItem } from '@pipi/shared';
import { Award, CalendarDays, Clock3, History, Play } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CoverArt } from '../components/cover-art';
import { EmptyState } from '../components/empty-state';
import { TvButton } from '../components/tv-button';
import { api } from '../lib/api';

export function HistoryPage() {
  const [history, setHistory] = useState<HistoryItem[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    void api.history().then(setHistory).finally(() => setLoading(false));
  }, []);
  if (!loading && !history.length) {
    return (
      <EmptyState
        title="第一首歌还在等你"
        description="完成演唱后，分数和历史会保存在这里。"
        action={<TvButton tone="primary" onClick={() => navigate('/')}><Play size={21} />开始第一首</TvButton>}
      />
    );
  }
  return (
    <div className="history-page">
      <section className="history-stats">
        <div><History /><span><strong>{history.length}</strong><small>已唱歌曲</small></span></div>
        <div><Award /><span><strong>{Math.max(0, ...history.map((item) => item.score ?? 0)).toLocaleString()}</strong><small>最高分</small></span></div>
        <div><Clock3 /><span><strong>{Math.round(history.length * 3.8)}</strong><small>欢乐分钟</small></span></div>
      </section>
      <section className="history-list">
        <header className="section-heading"><div><span>RECENT SESSIONS</span><h2>最近唱过</h2></div></header>
        {history.map((item) => (
          <article key={item.id} data-tv-focusable tabIndex={0} onClick={() => navigate(`/play/${encodeURIComponent(item.song.id)}`)}>
            <CoverArt song={item.song} />
            <div><h3>{item.song.title}</h3><p>{item.song.artist}</p></div>
            <span><small>演唱者</small><strong>{item.singer}</strong></span>
            <span><small><CalendarDays size={15} />{new Date(item.completedAt).toLocaleDateString('zh-CN')}</small><strong className="history-score">{item.score ? item.score.toLocaleString() : '—'}</strong></span>
            <Play size={22} />
          </article>
        ))}
      </section>
    </div>
  );
}
